import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// componenets
import Header from "./Components/Header";
import Content from "./Containers/Content";
import Footer from "./Components/Footer";
import Process from "./Components/Process";
import Work from "./Components/Work";
import ShowCase from "./Components/ShowCase";
import About from "./Components/About";
import Contact from "./Components/Contact";

class App extends Component {
  onMouseMove(e) {
    const target = document.querySelector(".cursor");
    if (target.id === "cursorBig") {
      target.style = `top:${e.pageY - 25}px;left:${e.pageX - 25}px`;
    } else {
      target.style = `top:${e.pageY - 8}px;left:${e.pageX - 8}px`;
    }
  }
  Scroll(){

              const offset=window.pageYOffset;
              const burgerMenu=document.querySelector('.burgerMenu');
              const navigation=document.querySelector('.nav_links');
              if(burgerMenu===null){
                return null;
              }
              else if(offset<=20){
                burgerMenu.style='display:none';
                navigation.style='display:grid';
              }else{
                burgerMenu.style = "display:flex";
                navigation.style = "display:none";
              }
            }
  cursorBiggerOnEnter() {
    document.querySelector(".cursor").id = "cursorBig";
  }
  cursorSmallerOnLeave() {
    document.querySelector(".cursor").id = "cursor";
  }
  render() {
    return (
      <Router>
        <div className="app_container" onMouseMove={this.onMouseMove} onWheel={this.Scroll}>
          <div className="cursor" id="cursor" />
          <Header
            address="this.state.address"
            runOnEnter={this.cursorBiggerOnEnter}
            runOnLeave={this.cursorSmallerOnLeave}
          />
          <Switch>
            <Route
              path="/"
              exact
              render={() => (
                <Content
                  runOnEnter={this.cursorBiggerOnEnter}
                  runOnLeave={this.cursorSmallerOnLeave}
                />
              )}
            />
            <Route
              path="/about"
              render={() => (
                <About
                  runOnEnter={this.cursorBiggerOnEnter}
                  runOnLeave={this.cursorSmallerOnLeave}
                />
              )}
            />
            <Route
              path="/process"
              render={props => (
                <Process
                  {...props}
                  runOnEnter={this.cursorBiggerOnEnter}
                  runOnLeave={this.cursorSmallerOnLeave}
                />
              )}
            />
            <Route
              path="/contact"
              render={() => (
                <Contact
                  runOnEnter={this.cursorBiggerOnEnter}
                  runOnLeave={this.cursorSmallerOnLeave}
                />
              )}
            />
            <Route
              path="/work"
              exact
              render={() => (
                <Work
                  runOnEnter={this.cursorBiggerOnEnter}
                  runOnLeave={this.cursorSmallerOnLeave}
                />
              )}
            />
            <Route
              path="/work/:id"
              render={props => (
                <ShowCase
                  runOnEnter={this.cursorBiggerOnEnter}
                  runOnLeave={this.cursorSmallerOnLeave}
                  {...props}
                />
              )}
            />
            <Route
              render={() => (
                <Content
                  runOnEnter={this.cursorBiggerOnEnter}
                  runOnLeave={this.cursorSmallerOnLeave}
                />
              )}
            />
          </Switch>
          <Footer
            runOnEnter={this.cursorBiggerOnEnter}
            runOnLeave={this.cursorSmallerOnLeave}
          />
        </div>
      </Router>
    );
  }
}

export default App;
